import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Accordion as Component } from '../components/accordion';
import styles from '../styles/desktop.css';
import type { IDeps, TAccordionDesktop } from '../models';

export const AccordionDesktop = createWidget<IDeps, TAccordionDesktop>({ styles })(Component);
